(function () {
  if (window.StaffCartEngagementInitialized) return;
  window.StaffCartEngagementInitialized = true;

  const ANALYTICS_WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbzJTW04xyFtaO7SXGWMANDyzbc7tTRLyqNsU44RnnkyVQ8RDS8wUH3n-J5HteMa8AFoqg/exec';

  function getParam(name) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name) || '';
  }

  function getStoredTrackingData() {
    try {
      const raw = sessionStorage.getItem('scb_tracking_data');
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  }

  function getTrackingData() {
    const stored = getStoredTrackingData();

    return {
      cartSessionId: getParam('scb_sid') || stored.cartSessionId || '',
      cartReferenceCode: getParam('scb_ref') || stored.cartReferenceCode || '',
      discountCode: getParam('discount') || stored.discountCode || '',
      sourceContext: getParam('scb_src') || stored.sourceContext || 'staff_cart_builder'
    };
  }

  function hasTrackingData() {
    const tracking = getTrackingData();
    return !!(tracking.cartSessionId && tracking.cartReferenceCode);
  }

  function getRestoredStorageKey(sessionId) {
    return `scb-cart-restored-${sessionId}`;
  }

  async function postAnalyticsEvent(payload) {
    if (!ANALYTICS_WEBHOOK_URL || ANALYTICS_WEBHOOK_URL === 'PASTE_YOUR_WEB_APP_URL_HERE') {
      return;
    }

    try {
      const iframeId = 'staff-cart-engagement-analytics-frame';
      let iframe = document.getElementById(iframeId);

      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.name = iframeId;
        iframe.id = iframeId;
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = ANALYTICS_WEBHOOK_URL;
      form.target = iframeId;
      form.style.display = 'none';

      const field = document.createElement('textarea');
      field.name = 'payload';
      field.value = JSON.stringify(payload);

      form.appendChild(field);
      document.body.appendChild(form);
      form.submit();

      setTimeout(() => {
        form.remove();
      }, 1000);
    } catch (error) {
      console.warn('Engagement analytics logging failed:', error);
    }
  }

  function buildBasePayload(eventType, cart) {
    const tracking = getTrackingData();

    return {
      eventId: `${eventType}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      eventTimestamp: new Date().toISOString(),
      eventType,
      cartSessionId: tracking.cartSessionId || '',
      cartReferenceCode: tracking.cartReferenceCode || '',
      staffName: '',
      staffId: '',
      storeLocation: '',
      clientName: '',
      clientContact: '',
      remarks: '',
      discountCode: tracking.discountCode || '',
      generatedLink: window.location.href,
      itemCount: cart && Array.isArray(cart.items) ? (cart.item_count || cart.items.length) : 0,
      items: cart && Array.isArray(cart.items)
        ? cart.items.map((item) => ({
            variantId: item.variant_id,
            productTitle: item.product_title,
            variantTitle: item.variant_title || '',
            quantity: item.quantity
          }))
        : [],
      pageUrl: window.location.href,
      userAgent: navigator.userAgent,
      sourceContext: tracking.sourceContext || 'staff_cart_builder'
    };
  }

  async function fetchCartJson() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error(`Cart fetch failed with status ${response.status}`);
    }

    return response.json();
  }

  async function waitForRestoredCart(maxAttempts, delayMs) {
    for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
      try {
        const cart = await fetchCartJson();
        if (cart && Array.isArray(cart.items) && cart.items.length) {
          return cart;
        }
      } catch (error) {
        console.warn('Cart restore polling attempt failed:', attempt, error);
      }

      if (attempt < maxAttempts) {
        await new Promise((resolve) => setTimeout(resolve, delayMs));
      }
    }

    return null;
  }

  async function logCartRestoredOnce() {
    const tracking = getTrackingData();

    if (!tracking.cartSessionId) return;
    if (!window.location.pathname.startsWith('/cart')) return;

    const storageKey = getRestoredStorageKey(tracking.cartSessionId);
    if (window.sessionStorage.getItem(storageKey)) return;

    const cart = await waitForRestoredCart(6, 1000);
    if (!cart) return;

    window.sessionStorage.setItem(storageKey, '1');
    await postAnalyticsEvent(buildBasePayload('cart_restored', cart));
  }

  function initEngagementTracking() {
    if (!hasTrackingData()) return;

    setTimeout(() => {
      logCartRestoredOnce();
    }, 1000);
  }

  document.addEventListener('DOMContentLoaded', initEngagementTracking);
})();